import { render, staticRenderFns } from "./WorkflowCreateStep.vue?vue&type=template&id=4730e7e4&scoped=true&"
import script from "./WorkflowCreateStep.vue?vue&type=script&lang=js&"
export * from "./WorkflowCreateStep.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowCreateStep.vue?vue&type=style&index=0&id=4730e7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4730e7e4",
  null
  
)

component.options.__file = "WorkflowCreateStep.vue"
export default component.exports